<template>
  <el-form
    :model="po"
    ref="requestForm"
    :rules="rules"
    style="padding: 15px"
    class="bg-white"
    label-position="top"
    v-loading="isLoading"
  >
    <h4 class="form-title">Purchase Order Information</h4>
    <div v-show="po.id ? true : false" class="text-center mb-1">
      <label>Status: <span v-text="po.status"></span></label>
      <!-- <el-form-item label="Purchase Order Status" prop="status">
        <el-input :readonly="true" v-model="po.status"></el-input>
      </el-form-item> -->
    </div>
    <el-row :gutter="15">
      <el-col :sm="12">
        <el-form-item label="Purchase Order No." prop="po_no">
          <el-input
            :readonly="po.id ? true : false"
            v-model="po.po_no"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :sm="12">
        <el-form-item label="Quote No." prop="quote_no">
          <el-input v-model="po.quote_no"></el-input>
        </el-form-item>
      </el-col>
    </el-row >
    <el-row :gutter="15">
      <el-col :sm="12">
        <el-form-item label="Supplier" prop="supplier_id">
          <el-select
            v-model="po.supplier_id"
            @change="getSupplier"
            v-if="!isReadOnly"
          >
            <el-option
              v-for="s in suppliers"
              :key="s.id"
              :value="s.id"
              :label="s.name"
            ></el-option>
          </el-select>
          <el-input
            v-else
            :readonly="true"
            row="4"
            v-model="supplier.name"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :sm="12">
        <el-form-item label="P.O Date." prop="po_date">
          <el-date-picker
            type="date"
            v-model="po.po_date"
            :default-value="po.po_date"
          ></el-date-picker>
        </el-form-item>
      </el-col>
     </el-row>
    <div v-show="supplier.id">
      <el-row :gutter="15">
        <el-col :sm="12">
          <el-form-item label="Contact Person">
            <el-input
              :readonly="true"
              row="4"
              v-model="supplier.contact_person"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="Telephone">
            <el-input
              :readonly="true"
              row="4"
              v-model="supplier.telephone"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="Address">
        <el-input
          :readonly="true"
          :rows="4"
          type="textarea"
          v-model="supplier.address"
        ></el-input>
      </el-form-item>
      <el-row :gutter="15" v-if="supplier.id">
        <el-col :sm="8">
          <el-form-item label="Currency">
            <el-input :readonly="true" v-model="currency.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="8">
          <el-form-item label="Sign">
            <el-input :readonly="true" v-model="currency.sign"></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="8">
          <el-form-item label="Amount in AED">
            <el-input :readonly="true" v-model="currency.rate"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
    <el-table v-show="supplier.id" :data="usedSR" class="mb-2">
      <!-- <el-table-column type="index" width="50" fixed></el-table-column> -->
      <el-table-column label="Action" width="60" v-if="po.id" fixed>
        <template slot-scope="scope">
          <el-button
            v-if="isPending(scope.row.item_status)"
            title="Item Complete"
            @click="itemComplete(scope.row)"
            size="small"
            type="success"
            icon="el-icon-check"
            circle
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="part_no"
        width="120"
        label="Part No."
        fixed
      ></el-table-column>
      <el-table-column
        prop="description"
        width="250"
        label="Description"
        fixed
      ></el-table-column>
      <el-table-column
        v-if="po_id"
        label="Status"
        prop="item_status"
        width="120"
      >
      </el-table-column>
      <el-table-column label="Quantity" width="120px">
        <template slot-scope="scope">
          <!-- <el-input
            v-if="!isReadOnly"
            v-model.number="scope.row.unit_price"
            type="number"
            step="0.01"
          ></el-input> -->
          <el-input-number
            v-if="!isReadOnly"
            v-model.number="scope.row.quantity"
            :controls="false"
            :min="1"
          ></el-input-number>
          <span v-else>{{ scope.row.quantity | number("0,0") }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="unit" label="Unit"></el-table-column>
      <el-table-column label="Unit Price" width="150px">
        <template slot-scope="scope">
          <!-- <el-input
            v-if="!isReadOnly"
            v-model.number="scope.row.unit_price"
            type="number"
            step="0.01"
          ></el-input> -->
          <el-input-number
            v-if="!isReadOnly"
            v-model.number="scope.row.unit_price"
            :controls="false"
            :precision="4"
            :min="0"
          ></el-input-number>
          <!-- <span v-else>{{
            scope.row.unit_price | currency(supplier.currency.sign, 4)
          }}</span> -->
          <span v-else>{{
            scope.row.unit_price | currency(currency.sign, 4)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Total" width="130">
        <template slot-scope="scope">
          <span>{{
            computeTotal(scope.row) | currency(currency.sign, 2)
          }}</span>
          <!-- <span>{{ computeTotal(scope.row) | currency("$ ", 2) }}</span> -->
        </template>
      </el-table-column>
      <el-table-column
        label="Received Quantity"
        width="130"
        prop="ordered_quantity"
      >
        <template slot-scope="scope">
          <span>{{
            "ordered_quantity" in scope.row
              ? scope.row.ordered_quantity
              : 0 | number("0,0")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="
          po.status == 'Pending Order' || !po.id
            ? 'Pending Quantity'
            : 'Remaining Quantity'
        "
        width="130"
        prop="remaining_quantity"
      >
        <template slot-scope="scope">
          <span>{{
            "remaining_quantity" in scope.row
              ? scope.row.remaining_quantity
              : scope.row.quantity | number("0,0")
          }}</span>
        </template>
      </el-table-column>
    </el-table>
    <p v-if="supplier.id">
      <label class="mr-3 el-form-item__label"
        >Total Amount:
        <b>{{ totalAmount | currency(currency.sign, 2) }}</b>
        <!-- <b>{{ totalAmount | currency("$ ", 2) }}</b> -->
      </label>
      <!-- <br />
      <label class="mr-3 el-form-item__label" v-if="currency.sign != 'USD'"
        >Total Amount (USD):
        <b>{{ (totalAmount / currency.rate) | currency("$ ", 2) }}</b>
      </label> -->
    </p>
    <div class="d-flex">
      <template v-if="!isReadOnly">
        <el-button type="primary" @click="savePO()" size="small"
          >Save</el-button
        >
        <el-button
          type="success"
          @click="viewdrawer = true"
          size="small"
          v-show="supplier.id"
          >Import Stock Request</el-button
        >
      </template>
      <template v-else>
        <!-- <el-button type="primary" @click="printPO()" size="mini"
          >Print</el-button
        > -->
        <router-link
          :to="{ name: 'purchaseorder_print', params: { id: po_id } }"
          target="_blank"
          class="el-button el-button--primary el-button--small"
          >Print</router-link
        >
      </template>
      <el-button
        v-if="po.status_id == 1"
        type="warning"
        size="small"
        @click="cancelPO"
        >Cancel Purchaser Order</el-button
      >
      <el-button
        v-if="po.status_id == 404"
        type="primary"
        size="small"
        @click="restorePO"
      >
        Restore Purchase Order
      </el-button>
      <el-button
        v-if="po.status_id == 404"
        type="danger"
        size="small"
        @click="deletePO"
      >
        Delete Purchase Order
      </el-button>
      <el-button size="small" @click="cancel">Cancel</el-button>
    </div>
    <el-drawer
      :visible.sync="viewdrawer"
      size="50%"
      ref="drawer"
      @open="drawerOpen"
      title="Approved Stock Requests"
      max-height="25"
    >
      <div class="el-drawer__content">
        <el-form>
          <el-table v-show="!isLoading" :data="unusedSR" ref="requestTable">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column label="Part No." prop="part_no"></el-table-column>
            <el-table-column
              label="Description"
              prop="description"
            ></el-table-column>
            <el-table-column label="Quantity" prop="quantity"></el-table-column>
          </el-table>
        </el-form>
        <div class="el-drawer__footer">
          <el-button size="mini" @click="$refs.drawer.closeDrawer()"
            >Cancel</el-button
          >
          <el-button size="mini" type="success" @click="importSR"
            >Import selected stock requests</el-button
          >
        </div>
      </div>
    </el-drawer>
  </el-form>
</template>
<script>
import PurchaseOrder from "@/models/PurchaseOrder";
import Supplier from "@/models/Supplier";
export default {
  name: "PurchaseOrderInfo",
  computed: {
    po_id() {
      return this.$route.params.id;
    },
    totalAmount() {
      var total = 0;
      this.usedSR.forEach(o => {
        total += o.total;
      });
      return total;
    },
    suppliers() {
      return this.$store.getters["supplier/glossary"];
    },
    unusedSR() {
      var list = this.$store.getters["stockrequest/list"];
      if (list.data.length)
        return list.data.filter(o => {
          return !this.usedSR.find(s => {
            return s.id == o.id;
          });
        });
      return [];
    },
    is_po_pending() {
      if (this.po.id) return this.po.status == "Pending Order";
      else return true;
    }
  },
  data() {
    return {
      isLoading: false,
      po: new PurchaseOrder(),
      supplier: {},
      rules: PurchaseOrder.rules(),
      viewdrawer: false,
      usedSR: [],
      isReadOnly: false,
      currency: {
        sign: "$",
        name: "USD",
        rate: 1
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    cancel() {
      this.$router.push({ name: "purchaseorder" });
    },
    init() {
      this.po = new PurchaseOrder();
      this.usedSR = [];
      this.isLoading = true;

      this.$store.dispatch("supplier/getGlossary").then(() => {
        if (this.$route.params.id) {
          this.isReadOnly = true;
          PurchaseOrder.fetch(this.$route.params.id).then(resp => {
            this.po = new PurchaseOrder(resp);
            this.supplier = new Supplier(this.po.supplier);
            this.po.requests.forEach(item => {
              this.usedSR.push({
                _default: item,
                quantity: item.quantity,
                unit: item.unit,
                unit_price: item.unit_price,
                total: item.total,
                description: item.part.description,
                part_no: item.part.part_no,
                part_id: item.part.id,
                item_status: item.status,
                item_id: item.id,
                req_id: this.$route.params.id,
                ordered_quantity: item.ordered_quantity,
                // item.ordered_quantity == 0 ? 0 : item.ordered_quantity,
                remaining_quantity: item.quantity - item.ordered_quantity
                // item.ordered_quantity > 0
                //   ? item.quantity - item.ordered_quantity
                //   : 0
              });
            });
            if ("currency_rate" in this.po && this.po.currency_rate) {
              let currency = JSON.parse(this.po.currency_rate);
              this.currency = {
                sign: currency.sign.toUpperCase() + " ",
                rate: currency.rate,
                name: currency.currency
              };
            } else {
              this.currency = {
                sign: this.supplier.currency.sign.toUpperCase() + " ",
                rate: this.supplier.currency.rate,
                name: this.supplier.currency.name
              };
            }
          });
        }
        this.isLoading = false;
      });
    },
    getSupplier() {
      this.isLoading = true;
      Supplier.fetch(this.po.supplier_id).then(resp => {
        this.supplier = new Supplier(resp);
        this.currency = {
          sign: resp.currency.sign.toUpperCase() + " ",
          rate: resp.currency.rate,
          name: resp.currency.name,
          id: resp.currency.id
        };
        this.isLoading = false;
      });
    },
    drawerOpen() {
      this.isLoading = true;
      this.$store.dispatch("stockrequest/getList", { status: 1, limit: 100 }).then(() => {
        this.isLoading = false;
      });
    },
    importSR() {
      var table = this.$refs["requestTable"];
      for (let item of table.selection) {
        var obj = {
          ...item,
          unit_price: 0,
          total: 0,
          unit: "pc"
        };
        this.usedSR.push(obj);
      }
      this.viewdrawer = false;
    },
    savePO() {
      this.$confirm("Are you sure you want to save this Purchase Order?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      })
        .then(() => {
          this.$refs["requestForm"].validate(valid => {
            if (!valid) return false;

            if (this.usedSR.length == 0) {
              this.$notify({
                type: "error",
                message: "Please import at least 1 request order.",
                position: "bottom-right"
              });
              return false;
            }

            for (let item of this.usedSR) {
              if (!item.unit_price) {
                this.$notify({
                  type: "error",
                  message:
                    "One of your imported Stock Request does not have a Unit Price.",
                  position: "bottom-right"
                });
                return false;
              }
            }

            this.$confirm("Delete the selected items from Stock Requests?", {
              confirmButtonText: "Yes",
              cancelButtonText: "No"
            })
              .then(() => {
                this.processSaving(1);
              })
              .catch(() => {
                this.processSaving(0);
              });
          });
        })
        .catch(() => {});
    },
    processSaving(is_delete) {
      var obj = {
        supplier_id: this.supplier.id,
        quote_no: this.po.quote_no,
        po_no: this.po.po_no,
        is_deleted: is_delete,
        po_date: this.po.po_date,
        requests: [],
        currency_rate: JSON.stringify({
          currency: this.supplier.currency.name,
          rate: this.supplier.currency.rate,
          sign: this.supplier.currency.sign
        })
      };
      for (let item of this.usedSR) {
        obj.requests.push({
          request_id: item.id,
          part_id: item.part_id,
          quantity: item.quantity,
          unit_price: item.unit_price,
          item_status: item.status
        });
      }
      this.isLoading = true;
      PurchaseOrder.create(obj).then(resp => {
        this.isLoading = false;
        if (resp && resp.code == 200) {
          this.$notify({
            type: "success",
            message: "Purchase Order created.",
            position: "bottom-right"
          });
          this.$router.push({ name: "purchaseorder" });
        }
      });
    },
    computeTotal(sr) {
      // sr.total = sr.quantity * sr.unit_price * this.currency.rate;
      sr.total = sr.quantity * sr.unit_price;
      return sr.total;
    },
    itemComplete(row) {
      this.$confirm(`Are you sure you want to complete this item request?`, {
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      })
        .then(() => {
          this.isLoading = true;
          PurchaseOrder.item_complete(row.item_id).then(resp => {
            // let req_id = row.req_id;
            this.isLoading = false;
            if (resp && resp.data.code == 200) {
              this.$notify({
                type: "success",
                message: resp.data.message,
                position: "bottom-right"
              });
            }
            // this.$router.push({
            //   name: "purchaseorder_info",
            //   params: { id: req_id }
            // });
            this.init();
          });
        })
        .catch(() => {});
    },
    isPending(status) {
      return status == "Pending Order" ? true : false;
    },
    cancelPO() {
      this.$confirm("Do you want to cancel this Purchase Order?")
        .then(() => {
          this.isLoading = true;
          PurchaseOrder.update({ id: this.po.id, status: 404 }).then(() => {
            this.$notify({
              message: "Purchase Order cancelled.",
              position: "bottom-left"
            });
            this.$router.push({ name: "purchaseorder" });
          });
        })
        .catch(() => {});
    },
    deletePO() {
      this.$confirm("Do you want to permanently delete this Purchase Order?")
        .then(() => {
          this.isLoading = true;
          PurchaseOrder.update({ id: this.po.id, status: 500 }).then(() => {
            this.$notify({
              message: "Purchase Order deleted permanently.",
              position: "bottom-left"
            });
            this.$router.push({ name: "purchaseorder" });
          });
        })
        .catch(() => {});
    },
    restorePO() {
      this.$confirm("Do you want to restore this Purchase Order?")
        .then(() => {
          this.isLoading = true;
          PurchaseOrder.update({ id: this.po.id, status: 1 }).then(() => {
            this.$notify({
              message: "Purchase Order restored.",
              position: "bottom-left"
            });
            this.$router.push({ name: "purchaseorder" });
          });
        })
        .catch(() => {});
    }
  }
};
</script>
